@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.ridepromocode
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateDto

class RidePromoCodeDto (
    val id: KmmLong?,
    val code: String,
    val isPercentage: Boolean,
    val percentage: Double,
    val amount: Double?,
    val currencyName: String?,
    val isAppOnly: Boolean,
    val expiration: DateDto?
)